export default "__VITE_ASSET__CNIc9RtM__"